// The Comic Machine - Landing UI

var LandingController = (function() {

  var config = {};

  // Handles UI and DOM manipulation
  var UI = {

    // DOM elements to manage
    elements: {},

    // Current view / list
    view: "creations",

    // Cache data
    data: {
      creations: null,
      published: null,
      sort: "title",
      order: "asc",
      autoPlay: false,
      autoLoop: false,
    },

    // Initialize the UI and DOM manager
    initialize: function() {

      // DOM elements to manage
      UI.elements = {
        app: document.querySelector(".app"),
        wrapper: document.querySelector(".landing-wrapper"),
        heading: document.querySelector(".landing-heading"),
        list: document.querySelector(".landing-list"),
        create: document.querySelectorAll(".create"),
        logout: document.querySelectorAll(".logout"),
        public: document.querySelectorAll(".public"),
        published: document.querySelectorAll(".published"),
        creations: document.querySelectorAll(".creations"),
        menu: document.querySelector(".menu-landing"),
        sort: document.querySelector("select[name='landing-sort-by']"),
        order: document.querySelector("select[name='landing-sort-order']"),
        menuItems: document.querySelectorAll(".menu-item-landing"),
        autoProgress: document.querySelector("input[name='landing-auto-progress']"),
        autoLoop: document.querySelector("input[name='landing-auto-loop']"),
      };

      if (API.authenticated) {

        // Get the comic data
        API.comics.query({}, function(success, response) {
          // Check for errors
          if (!success) return console.error(response);
          // Cache the data
          UI.data.creations = response;
          if (UI.data.published !== null) {
            UI.changeView(UI.view);
          }
        });

        // Get the comic data
        API.comics.query({
          published: true
        }, function(success, response) {
          // Check for errors
          if (!success) return console.error(response);
          // Cache the data
          UI.data.published = response;
          if (UI.data.creations !== null) {
            UI.changeView(UI.view);
          }
        });

      } else {

        // Get the public comic data
        API.comics.gallery({}, function(success, response) {
          // Check for errors
          if (!success) return console.error(response);
          // Cache the data
          UI.data.published = response;
          UI.changeView(UI.view);
        });

      }

      // Bind handlers to events
      UI.bindEvents();

    },

    // Bind handlers to events
    bindEvents: function() {

      // Handle on click of create new comic button
      attachHandler(UI.elements.create, function(event) {
        if (API.authenticated) {
          // Create a new comic instance
          if (UI.view === "creations") {
            Comic.create();
          } else {
            Events.global.emit("tcm.route", "/creator");
            // UI.changeView("creations", function() {
            window.setTimeout(Comic.create, 250);
            // });
          }
        } else {
          Events.global.emit("tcm.route", "/user/login");
        }
      });

      // Handle on click of all published comics button
      attachHandler(UI.elements.public, function(event) {
        API.users.logout(null, function() {
          Events.global.emit("tcm.route", "/gallery");
        });
      });

      // Handle on click of the my published comics button
      attachHandler(UI.elements.published, function(event) {
        // UI.changeView("published");
        Events.global.emit("tcm.route", "/gallery/published");
      });

      // Handle on click of the my creations button
      attachHandler(UI.elements.creations, function(event) {
        // UI.changeView("creations");
        Events.global.emit("tcm.route", "/creator");
      });

      // Handle sorting of list
      attachHandler(UI.elements.sort, function(event) {
        UI.data.sort = event.target.value;
        UI.changeView(UI.view);
      }, "change");
      attachHandler(UI.elements.order, function(event) {
        UI.data.order = event.target.value;
        UI.changeView(UI.view);
      }, "change");

      attachHandler(UI.elements.autoProgress, function(event) {
        UI.data.autoPlay = event.target.checked;
      }, "change");
      attachHandler(UI.elements.autoLoop, function(event) {
        UI.data.autoLoop = event.target.checked;
      }, "change");

      if (UI.data.autoPlay) {
        UI.elements.autoProgress.setAttribute("checked", "checked");
      }
      if (UI.data.autoLoop) {
        UI.elements.autoLoop.setAttribute("checked", "checked");
      }

      // Handle on click of logout button
      attachHandler(UI.elements.logout, function(event) {
        // Log the user out
        ComicController.logout(false);
      });

    },

    // Method to toggle the menu closed then auto
    toggleMenu: function() {

      UI.elements.menu.setAttribute("data-active", "false");

      window.setTimeout(function() {
        UI.elements.menu.setAttribute("data-active", "true");
      }, 500);

    },

    // Changes the current view / list on the landing page
    changeView: function(view, callback) {

      var comics = UI.data.published;
      var published = view === "creations" ? "false" : "true";
      var url = "gallery";

      switch (view) {

        case "public":
          // Update the heading
          UI.elements.heading.innerHTML = "All published comics";
          break;

        case "published":
          url += "/" + view;
          comics = [];
          UI.data.creations && UI.data.creations.forEach(function(comic) {
            if (comic && comic.published) {
              comics.push(comic);
            }
          });
          // Update the heading
          UI.elements.heading.innerHTML = "My published comics";
          break;

        case "creations":
          url = "creator";
          comics = UI.data.creations;
          // Update the heading
          UI.elements.heading.innerHTML = "My created comics";
          break;

      }

      for (var i = 0; i < UI.elements.menuItems.length; i++) {
        var item = UI.elements.menuItems[i];
        var active = item.className === "menu-item-landing " + view;
        item.setAttribute("data-active", active ? "true" : "false");
      }

      UI.elements.wrapper.setAttribute("data-published", published);
      UI.elements.app.setAttribute("data-published", published);
      UI.view = view;
      UI.renderList(comics);

      callback && callback();

    },

    // Method to sort the comics
    sortComics: function(comics, sort, order) {

      if (!comics) return;

      sort = sort || UI.data.sort;
      order = order || UI.data.order;

      var asc = order === "asc";

      return comics.sort(function(a, b) {
        if (sort === "title") {
          if (a.title < b.title) return asc ? -1 : 1;
          if (a.title > b.title) return asc ? 1 : -1;
          return 0;
        } else if (sort === "date") {
          if (a.date < b.date) return asc ? -1 : 1;
          if (a.date > b.date) return asc ? 1 : -1;
          return 0;
        }
        return 0;
      });

    },

    // Method to render list of comics
    renderList: function(comics) {

      var list = document.createDocumentFragment();

      comics = UI.sortComics(comics);

      // Loop over comics
      comics && comics.forEach(function(comic) {

        var item = document.createElement("li");
        var date = new Date(comic.date).toDateString();
        var div = document.createElement("div");

        // TODO: Update for production paths
        // TODO: Script the change in the database once ready
        var thumbnail = comic.pages[0].thumbnail.replace(
          "api-stage.thecomicmachine.com:8090/assets",
          "assets.stage.thecomicmachine.com"
        );
        thumbnail = thumbnail.replace(
          "api.stage.thecomicmachine.com/assets",
          "assets.stage.thecomicmachine.com"
        );
        var thumb = "background-image:url('" + thumbnail + "')";
        var title = comic.title ? comic.title : "&nbsp;";
        var series = comic.series ? comic.series : "&nbsp;";
        var author = comic.author ? "by " + comic.author : "&nbsp;";
        var remove = UI.view === "creations";

        var sharing = [
          '<span class="comic-share">',
          'Share',
          '<a href="#" class="comic-share-item" title="Share on Facebook" data-network="facebook" data-uid="', comic.uid, '">',
          '<img src="/images/icon-share-facebook.svg" alt="Facebook icon">',
          '</a>',
          '<a href="#" class="comic-share-item" title="Share on Twitter" data-network="twitter" data-uid="', comic.uid, '">',
          '<img src="/images/icon-share-twitter.svg" alt="Twitter icon">',
          '</a>',
          '</span>',
        ].join("");

        div.setAttribute("data-comic-uid", comic.uid);
        div.innerHTML += [
          '<span class="comic-thumb" style="', thumb, '"></span>',
          '<span class="comic-name" title="', title, '">', title, '</span>',
          '<span class="comic-series" title="', series, '">', series, '</span>',
          '<span class="comic-author" title="', author, '">', author, '</span>',
          remove ? '<span class="comic-remove">x</span>' : '',
          '<span class="comic-date">', date, '</span>',
          '<span class="comic-pages">', comic.pages.length, ' pages</span>',
          comic.published ? sharing : '',
          '<span class="comic-uid">', comic.uid, '</span>',
        ].join("");

        item.appendChild(div)
        list.appendChild(item);

      });

      // Replace the previous contents
      UI.elements.list.innerHTML = "";
      UI.elements.list.appendChild(list);

      // Handle click on comic item
      var items = UI.elements.list.querySelectorAll("li > div");
      for (var i = 0; i < items.length; i++) {
        items[i].onclick = UI.view === "creations" ? UI.selectComic : UI.viewComic;
      }

      // Handle click on share comic
      var share = UI.elements.list.querySelectorAll(".comic-share-item");
      for (var i = 0; i < share.length; i++) {
        share[i].onclick = UI.shareComic;
      }

    },

    // Method to select and load a comic
    viewComic: function(event) {

      event.preventDefault();

      var query = {
        uid: this.getAttribute("data-comic-uid"),
        published: true,
        keepNotification: true,
      };

      if (event.target.className === "comic-remove") {
        return UI.removeComic({
          uid: query.uid
        }, event.target.parentNode);
      }

      if (event.target.className === "comic-share-item") {
        return;
      }

      if (UI.view === "creations") {
        Events.global.emit("tcm.route", "/creator/comic/" + query.uid);
      } else {
        Events.global.emit("tcm.route", "/gallery/comic/" + query.uid);
      }

    },

    // Method to select and load a comic
    selectComic: function(event) {

      event.preventDefault();

      var uid = this.getAttribute("data-comic-uid");
      var query = {
        uid: uid
      };

      if (event.target.className === "comic-remove") {
        UI.removeComic(query, event.target.parentNode);
      } else if (event.target.className !== "comic-share-item") {
        query.keepNotification = true;
        // Query the comic to get the full data
        API.comics.query(query, function(success, response) {
          if (!success) return;
          window.setTimeout(function() {
            // Route to the creator page
            Events.global.emit("tcm.route", "/creator/comic/" + uid);
            var comic = response[0];
            comic.autoPlay = UI.data.autoPlay;
            comic.autoLoop = UI.data.autoLoop;
            // Load the comic data
            Comic.load(comic);
          }, 150);
        });
      }

    },

    // Method to remove / delete a comic
    removeComic: function(query, target) {

      var self = this;
      var message = "Are you sure you want to remove this comic?";

      if (!window.confirm(message)) {
        return;
      }

      // Remove the comic via the API
      API.comics.remove(query, function(success, response) {
        if (success) {
          UI.elements.list.removeChild(target.parentNode);
        } else {
          window.alert("An error occurred, please try again.");
        }
      });

    },

    // Method to share a comic
    shareComic: function(event) {

      event.preventDefault();
      event.stopPropagation();

      var url;
      var uid = this.dataset.uid;
      var link = window.encodeURIComponent(
        window.location.protocol + "//" +
        window.location.host +
        "/?comic=" + uid
      );

      switch (this.dataset.network) {
        case "facebook":
          url = [
            "https://www.facebook.com/sharer.php",
            "?u=", link,
          ].join("");
          break;
        case "twitter":
          url = [
            "https://twitter.com/intent/tweet",
            "?url=", link,
            // "&text=", "",
          ].join("");
          break;
      }

      if (!window.open(url, "_blank")) {
        window.location.href = url;
      }

    },

  };

  // Public / exposed object
  return UI;

})();
